module.exports = __webpack_public_path__ + "img/chrw.e63916e9.svg";